import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useApi } from 'api/api-context';
import { DASHBOARD_PAGE_PATH } from 'routes/paths';

interface Props {
  permission: string;
  children: ReactNode;
  redirect?: string;
}

/**
 * Prevents rendering a page unless the user has the given global permission.
 */
export default function RequireGlobalPermissionPage({
  permission,
  children,
  redirect = DASHBOARD_PAGE_PATH.original,
}: Props) {
  const { hasPermissionGlobally } = useApi();

  if (!hasPermissionGlobally(permission)) {
    return <Navigate to={redirect} replace />;
  }

  return <>{children}</>;
}
